import { render, staticRenderFns } from "./BannerSlide.vue?vue&type=template&id=0934fc16&"
import script from "./BannerSlide.vue?vue&type=script&lang=js&"
export * from "./BannerSlide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports